import React from 'react';
import { Link as MUILink } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    link: {
        textDecoration: 'none',
        color: theme.palette.primary.main,
        fontWeight: 'bold',
    },
});

class Link extends React.Component {
    render () {
        const { to, children, classes, ...other } = this.props;
        return (
            <Typography component='span'>
                <MUILink to={to} {...other} className={classes.link}>{children}</MUILink>
            </Typography>
        );
    }
}

export default withStyles(styles)(Link);